import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { UserCollege } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

export const useAgentContext = (colleges: readonly UserCollege[] | undefined) => {
  useRegisterAgentContext(
    colleges
      ? {
          kind: 'list',
          description: "The colleges previewed from the student's college list on their profile.",
          data: colleges.map((college) => ({
            id: college.id,
            name: college.name,
            status: college.status,
          })),
        }
      : null,
  );
};
